<template>
  <div class="scrollLazy" style="min-height: 0px">
    <div class="scrollLazy" style="min-height: 0px">
      <div class="style__footer__3lDH1" id="ob_footer">
        <div class="style__logbox__1U__O">
          <img src="/static/image/1608047280311172.png" /><img src="/static/image/1608047301174026.png" /><img src="/static/image/1608047320665608.png" /><img src="/static/image/1602060075775779.png" /><img src="/static/image/1602060091328212.png" /><img
            src="/static/image/1602060109820223.png"
          /><img src="/static/image/1602060124788196.png" /><img src="/static/image/1602060142308157.png" /><img src="/static/image/1602060157021979.png" /><img src="/static/image/1602060179784221.png" /><img src="/static/image/1602060194977049.png" /><img src="/static/image/1603003071894791.png" />
        </div>
        <hr />
        <div class="style__explanation__18qt1">
          <p>{{$store.state.appInfo.title}}拥有欧洲马耳他MGA和菲律宾政府（PAGCOR）颁发的合法牌照。 注册于英属维尔京群岛，是受国际协会认可的合法公司。进行注册并娱乐前，请确保您年满18周岁！</p>
        </div>
        <div class="style__logoList__2uccD">
          <div>
            <div></div>
            <span>马耳他牌照(MGA)认证</span>
          </div>
          <div>
            <div></div>
            <span>英属维尔京群岛(BVI)认证</span>
          </div>
          <div>
            <div></div>
            <span>菲律宾(PAGCOR)监督牌照</span>
          </div>
        </div>
        <div class="style__helpbox__2sqb7">
          <div @click="$parent.goNav('/abouts?type=1')">常见问题</div>
          <div @click="$parent.goNav('/abouts?type=2')">博彩责任</div>
          <div @click="$parent.goNav('/abouts?type=3')">隐私政策</div>
          <div @click="$parent.goNav('/abouts?type=4')">免责说明</div>
          <div @click="$parent.goNav('/abouts?type=5')">联络我们</div>
        </div>
        <p class="style__copyright__10clK">版权所有 ©2018-2022 {{$store.state.appInfo.title}} 保留所有权</p>
      </div>
    </div>
  </div>
</template>
<script>
//
export default {
  name: 'Foot',
  data() {
    return {};
  },
  methods: {
    
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
// @import '../../../static/css/chunk-611499bd.2ebefcf0.css';
</style>



// WEBPACK FOOTER //
// src/components/libs/Foot.vue